module.exports = __webpack_public_path__ + "img/mt-invoice-payment-qr.ae81c360.svg";